module.exports = __webpack_public_path__ + "static/media/BuyWithCard.6a022127.svg";